import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Popconfirm,
  Space,
  Card,
  Tag,
} from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import api from '../services/api';

const Empresas = () => {
  const [empresas, setEmpresas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingEmpresa, setEditingEmpresa] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    fetchEmpresas();
  }, []);

  const fetchEmpresas = async () => {
    setLoading(true);
    try {
      const response = await api.get('/empresas');
      setEmpresas(response.data);
    } catch (error) {
      message.error('Error al cargar empresas');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingEmpresa) {
        await api.put(`/empresas/${editingEmpresa.id}`, values);
        message.success('Empresa actualizada exitosamente');
      } else {
        await api.post('/empresas', values);
        message.success('Empresa creada exitosamente');
      }
      setModalVisible(false);
      form.resetFields();
      setEditingEmpresa(null);
      fetchEmpresas();
    } catch (error) {
      message.error('Error al guardar empresa');
    }
  };

  const handleEdit = (record) => {
    setEditingEmpresa(record);
    form.setFieldsValue(record);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await api.delete(`/empresas/${id}`);
      message.success('Empresa eliminada exitosamente');
      fetchEmpresas();
    } catch (error) {
      message.error('Error al eliminar empresa');
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
    },
    {
      title: 'Nombre',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'RUC',
      dataIndex: 'ruc',
      key: 'ruc',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono',
      key: 'telefono',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Contacto',
      dataIndex: 'contacto',
      key: 'contacto',
    },
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
      render: (estado) => {
        const colors = {
          activa: 'green',
          inactiva: 'red',
        };
        return <Tag color={colors[estado]}>{estado.toUpperCase()}</Tag>;
      },
    },
    {
      title: 'Acciones',
      key: 'acciones',
      render: (_, record) => (
        <Space>
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          >
            Editar
          </Button>
          <Popconfirm
            title="¿Estás seguro de eliminar esta empresa?"
            onConfirm={() => handleDelete(record.id)}
            okText="Sí"
            cancelText="No"
          >
            <Button type="primary" danger icon={<DeleteOutlined />}>
              Eliminar
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <Card
        title="Gestión de Empresas"
        extra={
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => {
              setEditingEmpresa(null);
              form.resetFields();
              setModalVisible(true);
            }}
          >
            Nueva Empresa
          </Button>
        }
      >
        <Table
          columns={columns}
          dataSource={empresas}
          rowKey="id"
          loading={loading}
        />
      </Card>

      <Modal
        title={editingEmpresa ? 'Editar Empresa' : 'Nueva Empresa'}
        open={modalVisible}
        onCancel={() => {
          setModalVisible(false);
          form.resetFields();
          setEditingEmpresa(null);
        }}
        footer={null}
        width={600}
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            name="nombre"
            label="Nombre"
            rules={[{ required: true, message: 'Ingresa el nombre de la empresa' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="ruc" label="RUC">
            <Input />
          </Form.Item>
          <Form.Item name="direccion" label="Dirección">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Form.Item name="telefono" label="Teléfono">
            <Input />
          </Form.Item>
          <Form.Item
            name="email"
            label="Email"
            rules={[{ type: 'email', message: 'Email inválido' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="contacto" label="Contacto">
            <Input />
          </Form.Item>
          <Form.Item name="estado" label="Estado" initialValue="activa">
            <Select>
              <Select.Option value="activa">Activa</Select.Option>
              <Select.Option value="inactiva">Inactiva</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item>
            <Space>
              <Button type="primary" htmlType="submit">
                {editingEmpresa ? 'Actualizar' : 'Crear'}
              </Button>
              <Button
                onClick={() => {
                  setModalVisible(false);
                  form.resetFields();
                  setEditingEmpresa(null);
                }}
              >
                Cancelar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default Empresas;

